jQuery(document).ready(function($){

  const selectors = {
  letterTag: '[data-letter-tag]',
  mobileSelect: '.blogGlossary_filterSelect',
  letterAnchor: '[data-letter]'
}

$(selectors.letterTag).on('click', (evt) => {
  const headerOffset = $('.section-header').height();
  var letter = $(evt.currentTarget).data('letter-tag');
  var currentTag = $(
    `${selectors.letterAnchor}[data-letter='${letter}']`
  );
  var currentTagLocation  = $(currentTag).offset().top - (1.5 * headerOffset);
  window.scroll({top: currentTagLocation, behavior: 'smooth'});
  return false;
})

$(selectors.mobileSelect).on('change', (evt) => {
 
  const headerOffset = $('.section-header').height();
  var letter = $(evt.currentTarget).val();
  var currentTag = $(
    `${selectors.letterAnchor}[data-letter='${letter}']`
  );
  var currentTagLocation  = $(currentTag).offset().top - (1.5 * headerOffset);
  window.scroll({top: currentTagLocation, behavior: 'smooth'});
  return false;
})
  
  var uniqueLetters = new Set(); // Use a Set to store unique letters
$('.blogGlossary_posts_char li').each(function () {
    var letter = $('a', this).text().charAt(0).toUpperCase(); // Get the uppercase first letter
    
    // Check if the letter is not in the Set
    if (!uniqueLetters.has(letter)) {
        uniqueLetters.add(letter); // Add the letter to the Set        
        // Create a new group for this letter
        var groupHTML = '<div class="cont cf"><div class="glossary-group__name-wrapper"><span class="glossary-group__name" id="'+ letter+'">'+ letter +'</span></div><ul data-letter="'+ letter+'" class="glossary-group__container cf"></ul></div>';
        
        // Append the group HTML to the parent container
        $(this).parent().append(groupHTML);    }
    
    // Append the list item to the corresponding letter group
    $(this).parent().find('[data-letter="'+ letter +'"]').append(this);
});


$('.blogGlossary_blogs_main-below').hide();

$('.Glossary-click').click(function (e) {
  e.preventDefault(); // Prevent the default link behavior

  var clickedBlock = $(this).parent().find('.blogGlossary_blogs_main-below');

  // Toggle the class on the clicked block
  clickedBlock.slideToggle(function () {
    // Toggle the active class on the parent li
    var parentLi = $(this).closest('li');
    parentLi.toggleClass('active-glossary', clickedBlock.is(':visible'));
  });

  // Close all other open blocks except the clicked one
  $('.blogGlossary_blogs_main-below').not(clickedBlock).slideUp(function () {
    // Remove the active class from the parent li for hidden blocks
    var parentLi = $(this).closest('li');
    parentLi.removeClass('active-glossary');
  });
});
});



$(document).ready(function () { 
  $('.glossary-search-input').on('input', function () {
    var searchTerm = $(this).val().toLowerCase();

    // Hide all category wrappers
    $('.blogGlossary_posts_char').hide();

    // Filter and show only the category wrappers that contain the search term
    $('.blogGlossary_posts_char').filter(function () {
      return $(this).text().toLowerCase().includes(searchTerm);
    }).show();
  });
});

  document.getElementById('Glossary').addEventListener('submit', function (event) {
        event.preventDefault();
        handleFormSubmission();
    });

    function handleFormSubmission() {

    } 